import React, { useState } from "react";
import { injectIntl } from "react-intl";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import hand from "../../assets/mano.png";
import NextButton from "../../components/NextButton";
import ScenarioBar from "../../components/ScenarioBar";
import { SERVER_URL } from "../../api";
import { useGameTexts } from "../../hooks/useGameTexts";
import { ROUTES } from "../../utils/constants";
import { getScenarioByScreen, stripHtml } from "../../utils/helpers";

const DEFAULT_INSTRUCTION = "Fíjate bien en este gráfico y avanza para responder la pregunta.";
const DEFAULT_BUTTON_TEXT = "IR A LA PREGUNTA";

function buildImageUrl(value) {
	if (!value || typeof value !== "string") return null;
	if (value.startsWith("http")) return value;
	return `${SERVER_URL.replace(/\/$/, "")}/${value.replace(/^\//, "")}`;
}

function Scenario5Explanation({ intl }) {
	const location = useLocation();
	const group = useSelector((state) => state?.group);
	const scenarioNum = getScenarioByScreen(location.pathname);
	const { texts, ready } = useGameTexts(group?.game);

	const instruction = ready && texts["scenario5.explanation.instruction"] != null
		? stripHtml(texts["scenario5.explanation.instruction"])
		: DEFAULT_INSTRUCTION;
	const buttonText = ready && texts["scenario5.explanation.buttonText"] != null
		? stripHtml(texts["scenario5.explanation.buttonText"])
		: DEFAULT_BUTTON_TEXT;
	const imageUrl = ready && texts["scenario5.explanation.image"]
		? buildImageUrl(texts["scenario5.explanation.image"])
		: null;

	const [imageLoaded, setImageLoaded] = useState(false);

	return (
		<div className="h-100 bg-prueba">
			<div className="container">
				<div className="row h-100">
					<div className="d-flex justify-content-start align-items-center">
						<img src={hand} alt="" />
						<div className="txt-white ms-2">
							{!ready ? "Cargando..." : instruction}
						</div>
					</div>
					<div className="d-flex justify-content-start align-items-center">
						{!ready ? (
							<div style={{ width: "95%", height: 300, background: "#e0e0e0", borderRadius: 8 }} aria-hidden />
						) : imageUrl ? (
							<img
								width="95%"
								src={imageUrl}
								alt=""
								style={{ opacity: imageLoaded ? 1 : 0.5, transition: "opacity 0.2s ease" }}
								onLoad={() => setImageLoaded(true)}
							/>
						) : (
							<div style={{ width: "95%", height: 300, background: "#e0e0e0", borderRadius: 8 }} aria-hidden />
						)}
					</div>
				</div>
			</div>
			<div
				className="container"
				style={{
					position: "absolute",
					bottom: "13vh",
					zIndex: 1000,
				}}
			>
				<div className="d-flex justify-content-end">
					<NextButton
						navigateTo={ROUTES.SCENARIO5}
						text={buttonText || DEFAULT_BUTTON_TEXT}
					/>
				</div>
			</div>
			<ScenarioBar activeScenario={scenarioNum}></ScenarioBar>
		</div>
	);
}

export default injectIntl(Scenario5Explanation);
